import Colors from "styles/colors";

const packageStatus = [
  "Created/Packaged",
  "Available for Pickup",
  "In Route",
  "Delayed",
  "Delivered",
];

const PackageLifecycle = {
  CREATED: "created/packaged",
  AVAILABLE_FOR_PICKUP: "availableForPickup",
  IN_ROUTE: "inRoute",
  DELAYED: "delayed",
  DELIVERED: "delivered",
  AVAILABLE_FOR_PICKUP_PG: "available_for_pickup",
  CREATED_PG: "created",
  IN_ROUTE_PG: "in_route",
};

const getLifeCycleStateTranslatedKeysPG = (lifecycleType, t) => {
  let lifecycleStateName;

  if (lifecycleType === PackageLifecycle.CREATED_PG) {
    lifecycleStateName = t("partview-dashboard:Created");
  }

  if (lifecycleType === PackageLifecycle.IN_ROUTE_PG) {
    lifecycleStateName = t("partview-dashboard:In Route");
  }
  if (lifecycleType === PackageLifecycle.DELAYED) {
    lifecycleStateName = t("partview-dashboard:Delayed");
  }

  if (lifecycleType === PackageLifecycle.DELIVERED) {
    lifecycleStateName = t("partview-dashboard:Delivered");
  }

  if (lifecycleType === PackageLifecycle.AVAILABLE_FOR_PICKUP_PG) {
    lifecycleStateName = t("partview-dashboard:Available for Pickup");
  }

  return lifecycleStateName ? lifecycleStateName : null;
};

const getLifeCycleStateTranslatedKeys = (lifecycleType, t) => {
  let lifecycleStateNameAndColor = null;

  switch (lifecycleType) {
    case PackageLifecycle.CREATED:
      return (lifecycleStateNameAndColor = {
        lifecycleStateName: t("partview-dashboard:Created/Packaged"),
        color: Colors.packageStatus.CREATED,
      });

    case PackageLifecycle.AVAILABLE_FOR_PICKUP:
      return (lifecycleStateNameAndColor = {
        lifecycleStateName: t("partview-dashboard:Available for Pickup"),
        color: Colors.packageStatus.AVAILABLE_FOR_PICKUP,
      });

    case PackageLifecycle.IN_ROUTE:
      return (lifecycleStateNameAndColor = {
        lifecycleStateName: t("partview-dashboard:In Route"),
        color: Colors.packageStatus.IN_ROUTE,
      });

    case PackageLifecycle.DELAYED:
      return (lifecycleStateNameAndColor = {
        lifecycleStateName: t("partview-dashboard:Delayed"),
        color: Colors.packageStatus.DELAYED,
      });

    default:
      return lifecycleStateNameAndColor;
  }
};

export const getFormattedLifecycleObject = (
  lifecycleObject,
  t,
  includeAPU = false,
) => {
  if (!lifecycleObject) {
    return [];
  }

  let totalActivePackages = 0;
  let lifecycleStates = { ...lifecycleObject };

  if (!includeAPU && lifecycleStates?.availableForPickup !== undefined) {
    delete lifecycleStates.availableForPickup;
  }

  for (let item in lifecycleStates) {
    if (item !== PackageLifecycle.DELIVERED) {
      totalActivePackages += lifecycleStates[item];
    }
  }

  const result = Object.entries(lifecycleStates).map(([key, count]) => {
    const translatedKeys = getLifeCycleStateTranslatedKeys(key, t);
    const lifecycleStateName = translatedKeys?.lifecycleStateName ?? null;
    const color = translatedKeys?.color ?? null;

    return {
      name: `${lifecycleStateName} (${count.toLocaleString()})`,
      key: lifecycleStateName,
      type: lifecycleStateName,
      count: count,
      searchOption: lifecycleStateName,
      fill: color,
      label: { text: count.toLocaleString() },
      totalActivePackages: totalActivePackages,
      widgetType: "Status",
      widgetVerb: "in",
    };
  });

  return result
    ? packageStatus
        .map((name) => result.find((item) => item.key === name))
        .filter((value) => value !== undefined)
    : null;
};

export const getFormattedLifecycleObjectPG = (lifecycleObject, t) => {
  let result;
  if (!lifecycleObject) {
    return [];
  } else {
    result = Object.entries(lifecycleObject).map((lifecycleCount) => {
      return {
        type: getLifeCycleStateTranslatedKeysPG(lifecycleCount[0], t),
        count: lifecycleCount[1],
      };
    });
  }

  return result ? result.filter((keys) => keys.type !== null) : null;
};
